export const SUCCESS = 'successful';
export const FAILED = 'failed';
export const RUNNING = 'running';
export const VALIDATION = 'validation';
export const VALIDATING = 'Validating';
export const VALIDATION_FAILED = 'Validation Failed';
export const VALIDATED = 'Validated';
